import React from 'react';
import ReactDOM from 'react-dom';


class ColumnPicker extends React.Component {
    constructor(props) {
        super(props);
        this.renderOption = this.renderOption.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.isChecked = this.isChecked.bind(this);

        if(!localStorage.getItem('columns_'+this.props.storage)) {
            let items = [];

            for(let i in this.props.columns) {
                if(this.props.columns[i].default === true) {
                    items.push(this.props.columns[i].key);
                }
            }
            localStorage.setItem('columns_'+this.props.storage,items);
        }
    }

    componentDidMount() {
        this.props.update(localStorage.getItem('columns_'+this.props.storage).split(','));
    }

    isChecked(key) {
        let data = localStorage.getItem('columns_'+this.props.storage);

        if(!data) {
            return false;
        }

        return data.split(',').includes(key);

    }

    handleChange(e) {
        let key = e.target.getAttribute('data-key');
        let data = localStorage.getItem('columns_'+this.props.storage);

        if(!data) {
            data = '';
        }

        data = data.split(',');

        if (data.includes(key)) {
            data = data.filter(item => {
                return item == key ? false:true;
            });
        }else{
            data.push(key);
        }

        data = data.filter(item => {
            return item == '' ? false:true;
        });

        localStorage.setItem('columns_'+this.props.storage,data.join(','));

        this.props.update(data)

    }

    renderOption(type) {
        return (
            <a className="dropdown-item" href="javascript:void(0)" role="menuitem" key={type.key}>
                <div style={{display:'inline-block',marginRight: '10px'}}  className="checkbox-custom checkbox-primary">
                    <input type="checkbox" id={this.props.storage+'_'+type.key} data-key={type.key} onChange={this.handleChange} checked={this.isChecked(type.key)}/>
                    <label htmlFor={this.props.storage+'_'+type.key}>{type.text}</label>
                </div>
            </a>
        );
    }


    render() {
        return (
            <div style={{marginRight:'10px'}} className="column-picker btn-group dropdown">
                <button type="button" className="btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <i className="icon wb-settings"></i>
                </button>
                <div className="dropdown-menu dropdown-menu-bullet dropdown-menu-right" role="menu">
                {
                    this.props.columns.map(type => {
                        return this.renderOption(type);
                    })
                }
                </div>
            </div>
        );
    }
}

export default ColumnPicker;


// WEBPACK FOOTER //
// ./components/ColumnPicker.js